/**
 * @Description 机会点详情信息-共通方法
 */

import { getChancePointDetail } from '@/common/api/expandStore/chancepoint';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { ChanceDetailModule } from '@/common/components/business/ExpandStore/ts-config';
import { ControlType, formDataComsToTiled } from '@/common/components/business/DynamicComponent/config';
import { meituanReportYHTIdentification } from '@/common/components/business/DynamicComponent/customize';
/**
 * @description 获取机会点所有字段信息
 * @param chanceId 机会点id
 * @return
 */
export const getChancepointAllFileds = async (chanceId: number) => {
  const data = await getChancePointDetail({ id: chanceId });
  const { moduleDetails } = data || {};
  if (!isArray(moduleDetails)) return null;

  const detailModule = moduleDetails.find(mod => mod.moduleType === ChanceDetailModule.Detail);
  if (!isNotEmptyAny(detailModule)) return null;

  const allFields = getAllFields(detailModule);
  // console.log('拿到机会点详情平铺信息', allFields);
  return allFields;
};

/**
 * @description 获取指定识别符属性
 * @param fileds 所有属性
 * @param identification 识别符
 * @return
 */
export const getFieldWithIdentification = (fileds: any[], identification: string) => {
  if (!isArray(fileds) || !fileds.length) return null;

  const field = fileds.find((itm: any) => itm.identification === identification);
  if (!isNotEmptyAny(field)) return null;

  return field;
};

/**
 * @description 获取机会点详情模块中的所有字段信息
 * @param detailModule 详情模块
 * @return
 */
export const getAllFields = (detailModule: any) => {
  if (!detailModule || !isNotEmptyAny(detailModule.infoModule)) return null;
  const { propertyGroupVOList } = detailModule.infoModule;
  if (!isArray(propertyGroupVOList) || !propertyGroupVOList.length) return null;

  const allComs: any = [];
  formDataComsToTiled(propertyGroupVOList, allComs); // 将组件对象平铺到数组中
  return allComs;
};

/**
 * @description 获取美团报告property（0724-目前未被用到）
 * @param id 机会点id
 * @return
 */
export const getMeituanReportProperty = async (id) => {
  const fields = await getChancepointAllFileds(id);
  if (!isArray(fields) || !fields.length) return null;

  const propertyItem = getFieldWithIdentification(fields, meituanReportYHTIdentification);
  return propertyItem;
};

/**
 * @description 获取是否有益禾堂预测营业额（0724-目前未被用到）
 * @param id 机会点id
 * @return
 */
export const getESTIMATE_SALES_CONCLUSION_YHT = async (id) => {
  const fields = await getChancepointAllFileds(id);
  if (!isArray(fields) || !fields.length) return null;
  // const propertyItem = fields.find((itm: any) => itm.controlType === 44);
  const propertyItems = fields.filter((itm) => ([
    ControlType.ESTIMATE_SALES_MT_MEAN_YHT.value,
    ControlType.ESTIMATE_SALES_MT_MAX_YHT.value,
    ControlType.ESTIMATE_SALES_CONCLUSION_YHT.value,
  ].includes(itm.controlType)));
  return propertyItems;
};
